import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { customFetchBase } from "../customFetchBase";

export const adminsApi = createApi({
  reducerPath: "adminsApi",
  baseQuery: customFetchBase({ url: "pa/admins/" }),
  endpoints: (builder) => ({
    // Login with Pass
    usernamePassLogin: builder.mutation({
      query: ({ username, password }) => ({
        url: "auth/login/pass",
        method: "POST",
        body: { username, password },
      }),
    }),
    // Logout
    logoutAdmin: builder.mutation({
      query: () => ({
        url: "auth/logout",
        method: "DELETE",
      }),
    }),
    // Get All
    getAdmins: builder.query({
      query: ({ page = 1, search, code } = {}) => {
        let url = `?no_of_docs_each_page=25&page=${page}`;
        if (search) url += `&search=${search}`;
        if (code) url += `&code=${code}`;
        return {
          url,
          method: "GET",
        };
      },
    }),
    // Create Admin
    createAdmin: builder.mutation({
      query: (data) => ({
        method: "POST",
        body: data,
      }),
    }),
    // Update Admin
    updateAdmin: builder.mutation({
      query: (data) => ({
        method: "PUT",
        body: data,
      }),
    }),
    // Delete Admin
    deleteAdmin: builder.mutation({
      query: (code) => ({
        url: `?code=${code}`,
        method: "DELETE",
      }),
    }),
    // Who am i
    getWhoAmI: builder.query({
      query: (code) => ({
        url: `me`,
        method: "GET",
      }),
    }),
  }),
});
export const {
  useUsernamePassLoginMutation,
  useLogoutAdminMutation,
  useGetAdminsQuery,
  useUpdateAdminMutation,
  useDeleteAdminMutation,
  useGetWhoAmIQuery,
  useCreateAdminMutation
} = adminsApi;
